import PolicyPage from "../components/PolicyPage";
export default function Privacy() { return <PolicyPage namespace="privacy" />; }
